import { useEffect } from 'react';

import { useQuery } from '@tanstack/react-query';
import { useSelector } from 'react-redux';

import { useRefetchForStaleData } from 'hooks/useRefetchForStaleData';
import i18n, { loadTranslations } from 'i18n';
import { guestPortalIdSelector } from 'store/app/selectors';
import { accountIdSelector } from 'store/user/selectors';
import axiosApi from 'utils/axios';
import { checkIsWebviewReady } from 'utils/mobileApplication';

export const useDashboardLoader = () => {
  const guestPortalId = useSelector(guestPortalIdSelector);
  const accountId = useSelector(accountIdSelector);
  const { data, isLoading, error, refetch } = useQuery(
    ['GP_DATA', guestPortalId],
    async () => {
      const { data } = await axiosApi.get(`/acc/${accountId}/guest_portals/${guestPortalId}`);
      await loadTranslations(i18n, data?.settings?.language);
      return data;
    },
    {
      refetchOnWindowFocus: true,
    },
  );

  useRefetchForStaleData(refetch);

  useEffect(() => {
    checkIsWebviewReady();
  }, []);

  return {
    data,
    isLoading,
    error,
    refetch,
  };
};
